<template>
  <div
    class="flex items-center p-4 rounded-lg shadow-md"
    :class="[
      getStatusColor(),
      disposable ? 'cursor-pointer hover:opacity-80' : '',
    ]"
    @click="disposable ? $emit('close') : null"
  >
    <!-- İkon -->
    <div class="mr-3">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        v-if="getStatusIcon() === 'check-circle'"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        v-else-if="getStatusIcon() === 'x-circle'"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        v-else-if="getStatusIcon() === 'exclamation'"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        v-else-if="getStatusIcon() === 'information-circle'"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>

    <!-- Metin -->
    <div class="flex-1">
      <p class="font-semibold">{{ getStatusText() }}</p>
      <p class="text-sm">{{ text }}</p>
    </div>

    <!-- Kapatma Butonu (Disposable ise) -->
    <button
      v-if="disposable"
      class="ml-3 p-1 rounded-full hover:bg-opacity-20"
      @click.stop="$emit('close')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  status: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  disposable: {
    type: Boolean,
    default: true,
  },
});

const getStatusColor = () => {
  switch (props.status) {
    case "success":
      return "bg-green-500 text-white";
    case "error":
      return "bg-red-500 text-white";
    case "warning":
      return "bg-yellow-500 text-black";
    case "info":
      return "bg-blue-500 text-white";
    case "debug":
      return "bg-yellow-500 text-black";
    default:
      return "bg-gray-500 text-white";
  }
};

const getStatusIcon = () => {
  switch (props.status) {
    case "success":
      return "check-circle";
    case "error":
      return "x-circle";
    case "warning":
      return "exclamation";
    case "info":
      return "information-circle";
    case "debug":
      return "exclamation";
    default:
      return "";
  }
};

const getStatusText = () => {
  switch (props.status) {
    case "success":
      return "Başarılı";
    case "error":
      return "Hata";
    case "warning":
      return "Uyarı";
    case "info":
      return "Bilgi";
    case "debug":
      return "Debug";
    default:
      return "";
  }
};
</script>
